import type { AccountType } from '@/entities/account';
import { BUSINESS_ACCOUNT_PATH } from '@/shared/config';

export const openTradingAccUrl = (login: string, accType: AccountType) => {
  const params = new URLSearchParams({
    login: login,
    server:
      accType === 'spot' ? 'ttexchange.free2ex.net' : 'ttmarginal.free2ex.net',
  });

  const url = `https://live.free2ex.com/authentication?${params}`;

  window.open(url, '_blank');
};

export const openTradingTerminalUrl = (login: string, server: string) => {
  const params = new URLSearchParams({ login, server });

  window.open(`${BUSINESS_ACCOUNT_PATH}?${params}`, '_blank');
};
